// Uncomment the below to migrate to statefull component
// import HomeContainer from './HomeContainer'
import Home from './Home'

export { Home }
export default Home
// Uncomment the below to migrate to statefull component
// export { HomeContainer }
// export default { HomeContainer }



// WEBPACK FOOTER //
// ./src/pages/Home/index.js